var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyVisualWrapper",style:(_vm.styles)},[_c('div',[_c('img',{staticClass:"desktop_img img-fluid w-100",attrs:{"src":_vm.desktopImageUrl}}),_c('img',{staticClass:"mobile_img img-fluid w-100",attrs:{"src":_vm.mobileImageUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }